import { type MenuOption } from '@saviynt/design-system';

import { type AdvancedFilterState } from '../types';

import { ADVANCED_FILTERS_METHODS } from './global';

// Initial call constants
export const ENTITLEMENT_INI_CALL: Record<string, string> = {
  ADF: 'const_for_entitlement_ad_filter_call',
  COP: 'const_for_entitlement_column_picker_call',
} as const;

const ENTITLEMENT_INITIAL_FILTERS: AdvancedFilterState[] = [
  {
    label: 'Entitlement Name',
    value: 'entitlementDisplayName',
    category: 'Entitlement',
    method: 'search',
    isDisabled: false,
    isChecked: true,
  },
  {
    label: 'Entitlement Value',
    value: 'entitlementValue',
    category: 'Entitlement',
    method: 'search',
    isDisabled: false,
    isChecked: true,
  },
  {
    label: 'Entitlement Type',
    value: 'entitlementTypeName',
    category: 'Entitlement',
    method: 'search',
    isDisabled: false,
    isChecked: true,
  },
  {
    label: 'Sox Severity',
    value: 'entitlementSoxSeverity',
    category: 'Entitlement',
    method: 'search',
    isDisabled: false,
    isChecked: true,
  },
  {
    label: 'Sys Severity',
    value: 'entitlementSysSeverity',
    category: 'Entitlement',
    method: 'search',
    isDisabled: false,
    isChecked: true,
  },
  {
    label: 'Privileged Severity',
    value: 'entitlementPrivilegeSeverity',
    category: 'Entitlement',
    method: 'search',
    isDisabled: false,
    isChecked: true,
  },
  {
    label: 'Risk Type',
    value: 'riskType',
    category: 'Risk',
    method: 'search',
    isDisabled: false,
    isChecked: true,
  },
  {
    label: 'Risk Name',
    value: 'riskName',
    category: 'Risk',
    method: 'search',
    isDisabled: false,
    isChecked: true,
  },
  {
    label: 'Risk Priority',
    value: 'riskPriority',
    category: 'Risk',
    method: 'search',
    isDisabled: false,
    isChecked: true,
  },
  {
    label: 'Application',
    value: 'endpointName',
    category: 'Application',
    method: 'search',
    isDisabled: false,
    isChecked: true,
  },
];

export default ENTITLEMENT_INITIAL_FILTERS;

const ENTITLEMENT_TAB_LIST_AD_FILTER_CAT: Record<string, string> = {
  APPLICATION: 'Application',
  RISK: 'Risk',
  ENTITLEMENT: 'Entitlement',
} as const;

export const ENTITLEMENT_TAB_LIST_AD_FILTER: Record<
  string,
  AdvancedFilterState
> = {
  RISKNAME: {
    label: 'Risk Name',
    value: 'riskName',
    category: ENTITLEMENT_TAB_LIST_AD_FILTER_CAT.RISK,
    method: ADVANCED_FILTERS_METHODS.SEARCH,
  },
  RISKTYPE: {
    label: 'Risk Type',
    value: 'riskType',
    category: ENTITLEMENT_TAB_LIST_AD_FILTER_CAT.RISK,
    method: ADVANCED_FILTERS_METHODS.FIXED,
    options: [
      {
        label: 'SOD',
        value: 'SOD',
        isChecked: false,
      },
      {
        label: 'Critical Access',
        value: 'CRITICAL_ACCESS',
        isChecked: false,
      },
      {
        label: 'None',
        value: 'NONE',
        isChecked: false,
      },
    ],
  },
  PRIORITY: {
    label: 'Risk Priority',
    value: 'riskPriority',
    category: ENTITLEMENT_TAB_LIST_AD_FILTER_CAT.RISK,
    method: ADVANCED_FILTERS_METHODS.FIXED,
    options: [
      {
        label: 'Critical',
        value: 'CRITICAL',
        isChecked: false,
      },
      {
        label: 'Low',
        value: 'LOW',
        isChecked: false,
      },
      {
        label: 'Medium',
        value: 'MEDIUM',
        isChecked: false,
      },
      {
        label: 'High',
        value: 'HIGH',
        isChecked: false,
      },
    ],
  },
  ENTITLEMENTVALUE: {
    label: 'Entitlement Value',
    value: 'entitlementValue',
    category: ENTITLEMENT_TAB_LIST_AD_FILTER_CAT.ENTITLEMENT,
    method: ADVANCED_FILTERS_METHODS.SEARCH,
  },
  ENTITLEMENTTYPE: {
    label: 'Entitlement Type',
    value: 'entitlementTypeName',
    category: ENTITLEMENT_TAB_LIST_AD_FILTER_CAT.ENTITLEMENT,
    method: ADVANCED_FILTERS_METHODS.SEARCH,
  },
  SOXCRITICAL: {
    label: 'Sox Critical',
    value: 'entitlementSoxSeverity',
    category: ENTITLEMENT_TAB_LIST_AD_FILTER_CAT.ENTITLEMENT,
    method: ADVANCED_FILTERS_METHODS.FIXED,
    options: [
      {
        label: 'High',
        value: 'HIGH',
        isChecked: false,
      },
      {
        label: 'Low',
        value: 'LOW',
        isChecked: false,
      },
      {
        label: 'Medium',
        value: 'MEDIUM',
        isChecked: false,
      },
      {
        label: 'Very High',
        value: 'VERY_HIGH',
        isChecked: false,
      },
      {
        label: 'Very Low',
        value: 'VERY_LOW',
        isChecked: false,
      },
    ],
  },
  SYSCRITICAL: {
    label: 'Sys Critical',
    value: 'entitlementSysSeverity',
    category: ENTITLEMENT_TAB_LIST_AD_FILTER_CAT.ENTITLEMENT,
    method: ADVANCED_FILTERS_METHODS.FIXED,
    options: [
      {
        label: 'High',
        value: 'HIGH',
        isChecked: false,
      },
      {
        label: 'Low',
        value: 'LOW',
        isChecked: false,
      },
      {
        label: 'Medium',
        value: 'MEDIUM',
        isChecked: false,
      },
      {
        label: 'Very High',
        value: 'VERY_HIGH',
        isChecked: false,
      },
      {
        label: 'Very Low',
        value: 'VERY_LOW',
        isChecked: false,
      },
    ],
  },
  CONFIDENTIALITY: {
    label: 'Privileged',
    value: 'entitlementPrivilegeSeverity',
    category: ENTITLEMENT_TAB_LIST_AD_FILTER_CAT.ENTITLEMENT,
    method: ADVANCED_FILTERS_METHODS.FIXED,
    options: [
      {
        label: 'High',
        value: 'HIGH',
        isChecked: false,
      },
      {
        label: 'Low',
        value: 'LOW',
        isChecked: false,
      },
      {
        label: 'Medium',
        value: 'MEDIUM',
        isChecked: false,
      },
      {
        label: 'Very High',
        value: 'VERY_HIGH',
        isChecked: false,
      },
      {
        label: 'Very Low',
        value: 'VERY_LOW',
        isChecked: false,
      },
    ],
  },
  APPLICATION: {
    label: 'Application',
    value: 'endpointName',
    category: ENTITLEMENT_TAB_LIST_AD_FILTER_CAT.APPLICATION,
    method: ADVANCED_FILTERS_METHODS.SEARCH,
  },
} as const;

export const DEFAULT_FILTERS: string[] = [
  ENTITLEMENT_TAB_LIST_AD_FILTER.RISKNAME.value,
  ENTITLEMENT_TAB_LIST_AD_FILTER.RISKTYPE.value,
  ENTITLEMENT_TAB_LIST_AD_FILTER.PRIORITY.value,
  ENTITLEMENT_TAB_LIST_AD_FILTER.ENTITLEMENTVALUE.value,
  ENTITLEMENT_TAB_LIST_AD_FILTER.ENTITLEMENTTYPE.value,
  ENTITLEMENT_TAB_LIST_AD_FILTER.SOXCRITICAL.value,
  ENTITLEMENT_TAB_LIST_AD_FILTER.SYSCRITICAL.value,
  ENTITLEMENT_TAB_LIST_AD_FILTER.CONFIDENTIALITY.value,
  ENTITLEMENT_TAB_LIST_AD_FILTER.APPLICATION.value,
] as const;

export const ENTITLEMENT_TAB_LIST_INITIAL_FILTERS: AdvancedFilterState[] =
  Object.values(ENTITLEMENT_TAB_LIST_AD_FILTER).map((filter) => {
    const isDefaultFilter = DEFAULT_FILTERS.includes(filter.value);

    return {
      ...filter,
      isDisabled: false,
      isChecked: isDefaultFilter,
    };
  });

// List and Sort Action
export const ENTITLEMENT_LIST_SORT_ACTIONS: Record<string, MenuOption> = {
  NEWTOOLD: {
    label: 'Newest to Oldest',
    value: 'NEWTOOLD',
  },
  OLDTONEW: {
    label: 'Oldest to Newest',
    value: 'OLDTONEW',
  },
  ATOZ: {
    label: 'A to Z',
    value: 'ATOZ',
  },
  ZTOA: {
    label: 'Z to A',
    value: 'ZTOA',
  },
} as const;

export const ENTITLEMENT_LIST_SORT_ACTION_MAPPING: Record<string, string> = {
  [ENTITLEMENT_LIST_SORT_ACTIONS.NEWTOOLD.value]: 'DESC',
  [ENTITLEMENT_LIST_SORT_ACTIONS.OLDTONEW.value]: 'ASC',
  [ENTITLEMENT_LIST_SORT_ACTIONS.ATOZ.value]: 'ASC',
  [ENTITLEMENT_LIST_SORT_ACTIONS.ZTOA.value]: 'DESC',
  DESC: 'DESC',
  ASC: 'ASC',
} as const;

export interface EntitlementListSortFieldState {
  label: string;
  value: string;
  isChecked?: boolean;
  options?: string[];
}

export const ENTITLEMENT_LIST_SORT_FIELDS: Record<
  string,
  EntitlementListSortFieldState
> = {
  UPDATEDATE: {
    label: 'Last Updated',
    value: 'lastUpdated',
    options: [
      ENTITLEMENT_LIST_SORT_ACTIONS.NEWTOOLD.value,
      ENTITLEMENT_LIST_SORT_ACTIONS.OLDTONEW.value,
    ],
  },
  ENTITLEMENTVALUE: {
    label: ENTITLEMENT_TAB_LIST_AD_FILTER.ENTITLEMENTVALUE.label,
    value: 'entitlementValue',
    options: [
      ENTITLEMENT_LIST_SORT_ACTIONS.ATOZ.value,
      ENTITLEMENT_LIST_SORT_ACTIONS.ZTOA.value,
    ],
  },
  ENTITLEMENTTYPE: {
    label: ENTITLEMENT_TAB_LIST_AD_FILTER.ENTITLEMENTTYPE.label,
    value: 'entitlementType',
    options: [
      ENTITLEMENT_LIST_SORT_ACTIONS.ATOZ.value,
      ENTITLEMENT_LIST_SORT_ACTIONS.ZTOA.value,
    ],
  },
  RISKNAME: {
    label: ENTITLEMENT_TAB_LIST_AD_FILTER.RISKNAME.label,
    value: 'riskName',
    options: [
      ENTITLEMENT_LIST_SORT_ACTIONS.ATOZ.value,
      ENTITLEMENT_LIST_SORT_ACTIONS.ZTOA.value,
    ],
  },
};

export const DEFAULT_LIST_COLUMNS: string[] = [
  'riskPriority',
  'riskName',
  'riskType',
  'entitlementDisplayName',
  'entitlementType',
];
